const UINT_RANGE = 0x1_0000_0000;

function mix(value: number): number {
  let result = value | 0;
  result = Math.imul(result ^ (result >>> 16), 0x21f0aaad);
  result = Math.imul(result ^ (result >>> 15), 0x735a2d97);
  return (result ^ (result >>> 15)) >>> 0;
}

export function hash2(x: number, y: number, seed = 0): number {
  const a = Math.imul(x | 0, 0x1f123bb5);
  const b = Math.imul(y | 0, 0x5f356495);
  return mix(a ^ b ^ seed) / UINT_RANGE;
}

function fade(value: number): number {
  return value * value * (3 - 2 * value);
}

function lerp(a: number, b: number, amount: number): number {
  return a + (b - a) * amount;
}

export function noise2(x: number, y: number, seed = 0): number {
  const x0 = Math.floor(x);
  const y0 = Math.floor(y);
  const tx = fade(x - x0);
  const ty = fade(y - y0);
  const top = lerp(hash2(x0, y0, seed), hash2(x0 + 1, y0, seed), tx);
  const bottom = lerp(hash2(x0, y0 + 1, seed), hash2(x0 + 1, y0 + 1, seed), tx);
  return lerp(top, bottom, ty) * 2 - 1;
}

export function fbm2(x: number, y: number, octaves: number, seed = 0): number {
  let frequency = 1;
  let amplitude = 1;
  let total = 0;
  let weight = 0;

  for (let octave = 0; octave < octaves; octave += 1) {
    total += noise2(x * frequency, y * frequency, seed + octave * 977) * amplitude;
    weight += amplitude;
    frequency *= 2.03;
    amplitude *= 0.5;
  }

  return total / weight;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function smoothstep(edge0: number, edge1: number, value: number): number {
  const t = clamp((value - edge0) / (edge1 - edge0), 0, 1);
  return t * t * (3 - 2 * t);
}
